import * as React from 'react';
import { TableWrapper } from '../styles';
import GridRow from './row';
import { IItem } from './types';

interface IProps {
    list: IItem[];
    onReviewRequest: (requestId: number) => void;
}

const RequestListView = ({ list, onReviewRequest }: IProps) => (
    <TableWrapper className='table table-condensed table-striped table-bordered'>
        <thead>
            <tr style={{ backgroundColor: '#ddd' }}>
                <th>Name</th>
                <th>Alias</th>
                <th>Weeks</th>
                <th>Action</th>
            </tr>
        </thead>
        <tbody>
            {list.map((item) => (
                <GridRow
                    key={item.requestId}
                    data={item}
                    onReviewRequest={onReviewRequest}
                />
            ))}
        </tbody>
    </TableWrapper>
);

export default RequestListView;
